export default "__VITE_ASSET__BdnrHVK7__"